module.exports = __webpack_public_path__ + "img/ccb.355ab0a6.png";